export default function MySQL_DAYOFWEEK() {
  return (
    <div>
      <h2>MySQL_DAYOFWEEK</h2>    </div>
  );
}